import { Redirect } from 'expo-router';

import { AuthContainer, SignIn } from '@fhs/auth';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export default function SigninPage() {
  const enableSimplyAuth = useFlag('enable-simply-auth-flow');
  return enableSimplyAuth ? (
    <AuthContainer>
      <SignIn />
    </AuthContainer>
  ) : (
    <Redirect href="/(auth)/signin" />
  );
}
